import { useContext, useState } from 'react';
import ModalComponent from 'components/Common/Modal';
import { store } from 'components/Store';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import thousandCommas from 'components/Dashboard/helpers/thousandCommas';
import { AddTagsContent } from 'components/Dashboard/Influence/CrmContacts/AddTagsModal/AddTagsModal';
import useLoadInteractionTagOptions from 'components/Dashboard/Filters/useLoadInteractionTagOptions';

const AddTagsToInteractionsModal = ({ openState, interactions, onSuccess }) => {
  const { isOpen, setIsOpen } = openState ?? {};
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { generalApiCall } = useGeneralApiCall();
  const { dispatch } = useContext(store);
  const loadTagOptions = useLoadInteractionTagOptions();

  const count = interactions?.length ?? 0;

  const closeModal = () => {
    setIsOpen(false);
    setTags([]);
  };

  const handleAddTags = async () => {
    setIsLoading(true);
    const newTags = tags.map((tag) => tag.value);
    const response = await generalApiCall({
      method: 'post',
      pathname: '/api/crm-interaction/tag',
      requestProperties: { ids: interactions?.map((item) => item.id), tags: newTags },
      needsAuthentication: true,
      returnCompleteRequest: true,
    });
    setIsLoading(false);
    if (response?.status === 200) {
      createNotification(
        'success',
        `Tag${newTags.length > 1 ? 's' : ''} added to ${thousandCommas(count)} interaction${count === 1 ? '' : 's'} successfully`
      );
      // The interactions list page owns its own local state and doesn't know this tagging just
      // happened - reuse the same "list needs a refetch" signal it already listens for after
      // logging a new interaction.
      dispatch({ type: 'MODIFY_SECTION', parameter: 'interactionLogged', value: true });
      onSuccess?.();
      closeModal();
    }
  };

  return (
    <ModalComponent
      maxWidth={790}
      isOpen={isOpen}
      setIsOpen={closeModal}
      overlayClassName='react-modal-overlay adjustment-of-position'
    >
      <div className='pt-4'>
        <AddTagsContent
          titleText={count === 1 ? 'this interaction' : `${thousandCommas(count)} interactions`}
          contactsCount={count}
          isLoading={isLoading}
          addTagsToContacts={handleAddTags}
          setTags={setTags}
          tags={tags}
          closeModal={closeModal}
          loadTagOptions={loadTagOptions}
          unitLabel='interaction'
          roundedTagChips
          searchIcon
        />
      </div>
    </ModalComponent>
  );
};

export default AddTagsToInteractionsModal;
